import React from "react";
import ReactDOM from 'react-dom';
import mapboxgl from 'mapbox-gl';
import "./map.css"


class CustomMap extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lng: 5,
            lat: 34,
            zoom: 2
        };
    }


    componentDidMount() {
        const map = new mapboxgl.Map({
            container: this.mapContainer,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [this.state.lng, this.state.lat],
            zoom: this.state.zoom
        });
        map.addControl(new mapboxgl.NavigationControl())
        map.on('move', () => {
            this.setState({
                lng: map.getCenter().lng.toFixed(4),
                lat: map.getCenter().lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });
        });
    }

    render() {

        mapboxgl.accessToken = 'pk.eyJ1Ijoia3VuYS1hbmFyYmF5IiwiYSI6ImNrMnNqcXZjOTBnZDAzanBkbnNsNmp3bXIifQ.4U10S_viu7JzP4GluOph4w';

        return (
            <div>
                <div>
                    <div>
                        <h1>
                            Map
                        </h1>
                    </div>
                    <div>
                        <div className='sidebarStyle'>
                            <div>Longitude: {this.state.lng} | Latitude: {this.state.lat} | Zoom: {this.state.zoom}</div>
                        </div>
                        <div ref={el => this.mapContainer = el} className='mapContainer' />
                    </div>
                </div>
            </div>
        )
    }
}


export default CustomMap;



// WEBPACK FOOTER //
// ./src/Components/Map/Map.js